<template>
  <template v-if="isViewDelBtn()">
    <Remove :payload="{
      tag_id: fields.id,
    }" @onDeleted="onDeleted"/>
  </template>
  <div ref="createModal" class="modal fade" id="modal-tag" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ params.data.title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <template v-if="isNotLoad()">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <ul class="nav nav-tabs card-header-tabs nav-fill" data-bs-toggle="tabs">
                    <li class="nav-item">
                      <a href="#tabs-common" class="nav-link active" data-bs-toggle="tab"><!-- Download SVG icon from http://tabler-icons.io/i/home -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z" /><path d="M9 11v-5a3 3 0 0 1 6 0v5" /></svg>
                        Общее
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#tabs-seo" class="nav-link" data-bs-toggle="tab"><!-- Download SVG icon from http://tabler-icons.io/i/user -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-list-search me-1">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M11 15a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                          <path d="M18.5 18.5l2.5 2.5" />
                          <path d="M4 6h16" />
                          <path d="M4 12h4" />
                          <path d="M4 18h4" />
                        </svg>
                        SEO
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="card-body">
                  <div class="tab-content">
                    <div class="tab-pane active show" id="tabs-common">
                      <div class="mb-3">
                        <div class="row">
                          <div class="mb-3">
                            <label class="form-label">Название</label>
                            <input type="text" v-model="fields.name" class="form-control" placeholder="Название тега" />
                            <span :class="{'is-invalid': v$.name.$invalid && v$.name.$dirty}"></span>
                            <div class="invalid-feedback" v-for="error of v$.name.$errors" :key="error.$uid">
                              {{ error.$message }}
                            </div>
                          </div>
                          <div class="mb-3">
                            <Slug :payload="{
                                val: fields.slug,
                                tag_id: fields.id,
                                name: fields.name,
                              }" :validation="v$" @onChange="onChangeSlug" @onSync="onSyncSlug" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="tabs-seo">
                      <div class="mb-3">
                        <label class="form-label">H1</label>
                        <input type="text" v-model="fields.h1_seo" class="form-control" name="example-text-input" placeholder="H1" />
                        <span :class="{'is-invalid': v$.h1_seo.$invalid && v$.h1_seo.$dirty}"></span>
                        <div class="invalid-feedback" v-for="error of v$.h1_seo.$errors" :key="error.$uid">
                          {{ error.$message }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Title</label>
                        <input type="text" v-model="fields.title_seo" class="form-control" name="example-text-input" placeholder="Title" />
                        <span :class="{'is-invalid': v$.title_seo.$invalid && v$.title_seo.$dirty}"></span>
                        <div class="invalid-feedback" v-for="error of v$.title_seo.$errors" :key="error.$uid">
                          {{ error.$message }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Description</label>
                        <input type="text" v-model="fields.description_seo" class="form-control" name="example-text-input" placeholder="Description" />
                        <span :class="{'is-invalid': v$.description_seo.$invalid && v$.description_seo.$dirty}"></span>
                        <div class="invalid-feedback" v-for="error of v$.description_seo.$errors" :key="error.$uid">
                          {{ error.$message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex justify-content-center">
              <div class="spinner-border"></div>
            </div>
          </template>
        </div>
        <template v-if="isNotLoad()">
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">
              Отмена
            </button>

            <template v-if="isViewDelBtn()">
              <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#post-tags-remove">
                Удалить
              </button>
            </template>

            <button class="btn btn-primary ms-auto" @click="send" :class="{'disabled': isPending()}">
              <span class="spinner-border spinner-border-sm me-2" v-show="isPending()"></span>
              {{ params.data.btn }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {computed, reactive, ref, onMounted, defineComponent} from 'vue'
import {useVuelidate} from "@vuelidate/core"
import {required} from "@/plugins/vuelidator"
import createParams from "./services/params/create"
import updateParams from "./services/params/update"
import Helper from "@/services/Helper"
import Api from "./services/Api"
import Notify from "@/services/Notify"
import Slug from "./components/slug/Index"
import {requiredIf, helpers} from "@vuelidate/validators"
import Remove from "./components/remove/Index"

export default defineComponent({
  name: "CreateUpdate",
  components: {
    Slug,
    Remove,
  },
  setup(props, {emit}) {
    const createModal = ref(null);
    const fields = reactive(getFields())

    let load = ref(false)
    let pending = ref(false)
    let bootModal = null;
    let $externalResults = reactive({})
    let params = ref(getParams())

    const rules = computed(() => ({
      name: {
        required
      },
      slug: {
        required: helpers.withMessage(
            // todo не очень хорошо, рассинхрон с основным словарем-переводом
            "Это поле необходимо заполнить",
            requiredIf(() => !Helper.isEmpty(fields.id))
        )
      },
      h1_seo: {},
      title_seo: {},
      description_seo: {},
    }))

    const v$ = useVuelidate(rules, fields, {$externalResults});

    function getParams() {
      return {
        data: {
          title: "",
          btn: "",
          page: "",
        }
      }
    }

    function resetParams() {
      params.value = getParams()
    }

    function isNotLoad() {
      return load.value === false
    }

    function markLoad() {
      return load.value = true
    }

    function markUnload() {
      return load.value = false
    }

    function isPending() {
      return pending.value === true
    }

    function markPending() {
      return pending.value = true
    }

    function markUnpending() {
      return pending.value = false
    }

    function getFields() {
      return {
        id: null,
        name: '',
        slug: '',
        h1_seo: '',
        title_seo: '',
        description_seo: '',
      }
    }

    function validate(fn) {
      clearValidate()
      return v$.value.$validate().then((resp) => {
        if (resp === false) {
          Notify.error("Ошибка валидации")
          return false
        }
        fn()
      })
    }

    function clearValidate() {
      v$.value.$clearExternalResults()
      v$.value.$reset()
    }

    function showModal(event) {
      const button = event.relatedTarget
      const type = button.getAttribute('data-type')

      if (type === "create") {
        setParams(createParams)
        create(event)
      } else {
        setParams(updateParams)
        update(event)
      }
    }

    function setParams(val) {
      params.value = val
    }

    function create() {
      clearForm()
      markUnload()
    }

    function update(event) {
      const button = event.relatedTarget
      const id = button.getAttribute('data-id')

      Api.item({
        tag_id: id,
      }).then((resp) => {
        let item = resp.data.item
        setFields(item)
      }).catch(() => {})
      .finally(() => {
        markUnload()
      })
    }

    function setFields(item) {
      fields.id = item?.id ?? 0
      fields.name = item?.name ?? ""
      fields.slug = item?.slug ?? ""
      fields.h1_seo = item?.h1_seo ?? ""
      fields.title_seo = item?.title_seo ?? ""
      fields.description_seo = item?.description_seo ?? ""
    }

    function preShowModal() {
      markLoad()
      resetParams()
      clearValidate()
    }

    onMounted(() => {
      bootModal = new bootstrap.Modal(createModal.value, {
        backdrop: 'static',
        keyboard: false
      });

      createModal.value.addEventListener('shown.bs.modal', showModal);
      createModal.value.addEventListener('show.bs.modal', preShowModal);
    })

    function getPayload(obj) {
      const formData = new FormData()

      Object.entries(obj).forEach(([key, val]) => {
        if (val instanceof File || val instanceof Blob) {
          formData.append(key, val)
          return
        }

        if (Array.isArray(val) || typeof val === 'object') {
          formData.append(key, JSON.stringify(val))
          return
        }

        if (typeof val === 'boolean') {
          formData.append(key, val ? 'true' : 'false')
          return
        }

        if (typeof val === 'number') {
          if (Number.isFinite(val)) {
            formData.append(key, val.toString())
          }
          return
        }

        formData.append(key, val)
      })

      return formData
    }

    function send() {
      validate(() => {
        markPending()

        let obj = {
          name: fields.name,
          slug: fields.slug,
          h1_seo: fields.h1_seo,
          title_seo: fields.title_seo,
          description_seo: fields.description_seo,
        }

        if (fields.id && isPageUpdate()) {
          obj = Helper.mergeObject(obj, {
            tag_id: fields.id,
          })
        }

        let payload = getPayload(obj)
        
        params.value.action({
          modal: bootModal,
          payload,
        }).then((resp) => {
          clearForm()
          clearValidate()
          Notify.success(resp)
          if (isPageUpdate()) {
            emit("onUpdate")
          } else {
            emit("onCreate")
          }
        }).catch((resp) => {
          Notify.error(resp)
        }).finally(() => {
          markUnpending()
        })
      })
    }

    function clearForm() {
      let items = getFields()
      for (let key of Object.keys(items)) {
        fields[key] = items[key]
      }
    }

    function isPageUpdate() {
      return params.value.data.page === "update"
    }

    function isViewDelBtn() {
      return isPageUpdate()
    }

    async function onSyncSlug(status) {
      if (status === true) {
        let resp = await Api.item({
          tag_id: fields.id
        })

        let item = resp.data.item

        setFields(item)

        Notify.success("Синхронизировано")
      } else {
        Notify.error("Ошибка синхронизации")
      }
    }

    function onChangeSlug(val) {
      fields.slug = val
    }

    function onDeleted(val) {
      if (val === true) {
        emit("onDelete", true)
      } else {
        emit("onDelete", false)
      }
    }

    return {
      isNotLoad,
      v$,
      fields,
      createModal,
      send,
      isPending,
      params,
      isViewDelBtn,
      onSyncSlug,
      onChangeSlug,
      onDeleted,
    }
  }
})
</script>
<script setup lang="ts">
</script>